import { ObstacleSettings } from "./ObstacleSettings";



export class ObstacleMapData {
    /**
     * (RO) Index bunky v radce, na ktere se prekazka aktivuje
     */
    get cellId(): number { return this._cellId; }
    private _cellId: number;

    /**
     * (RO) Nastaveni prekazky
     */
    get settings(): ObstacleSettings { return this._settings; }
    private _settings: ObstacleSettings;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(cellId: number, settings: ObstacleSettings) {
        this._cellId = cellId;
        this._settings = settings;
    }
}